var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeMute = function SvgVolumeMute(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07782 9.4751C3 9.8192 3 10.2766 3 11.0292V12.9708C3 13.9301 3 14.4098 3.16115 14.7865C3.3635 15.2596 3.74039 15.6365 4.21347 15.8388C4.59023 16 5.0699 16 6.02924 16C6.35575 16 6.51901 16 6.67691 16.0254C6.87544 16.0574 7.06801 16.1191 7.24814 16.2085C7.3914 16.2796 7.52425 16.3745 7.78994 16.5642L10.8375 18.7411C12.2226 19.7304 12.9152 20.2251 13.4576 19.946C13.9993 19.6672 14 18.8181 14 17.1206L3.07782 9.4751ZM4.54786 8.06282L14 14.6793V6.88638C14 5.18423 14 4.33316 13.4576 4.05402C12.9152 3.77488 12.2226 4.26956 10.8375 5.25891L7.78994 7.43575L7.78993 7.43576C7.52425 7.62554 7.3914 7.72043 7.24814 7.79152C7.06801 7.88091 6.87544 7.94263 6.67691 7.97458C6.51901 8 6.35575 8 6.02924 8C5.32843 8 4.88359 8 4.54786 8.06282Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5L17 16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeMute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "volume-mute.6e8b1d46c44997e092effc5c9ead6745.svg";